import React from "react";
import { LOGO_URL } from "../lib/invitationData";

// Real wedding logo image (uploaded by user) with transparent background —
// no filtering needed.
export const Monogram = ({ size = 120, className = "" }) => (
    <img
        src={LOGO_URL}
        alt="Rayyan and Zuha monogram"
        width={size}
        height={size}
        loading="eager"
        className={className}
        style={{
            width: size,
            height: "auto",
            maxHeight: size,
            objectFit: "contain",
            display: "block",
        }}
    />
);

export const GoldDivider = ({ className = "" }) => (
    <div
        className={`flex items-center justify-center gap-3 ${className}`}
        aria-hidden="true"
    >
        <span className="block h-px w-16 bg-gradient-to-r from-transparent via-[color:var(--gold)]/70 to-transparent" />
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path
                d="M7 1 L8.5 5.5 L13 7 L8.5 8.5 L7 13 L5.5 8.5 L1 7 L5.5 5.5 Z"
                stroke="#b89658"
                strokeWidth="0.7"
                fill="none"
            />
        </svg>
        <span className="block h-px w-16 bg-gradient-to-l from-transparent via-[color:var(--gold)]/70 to-transparent" />
    </div>
);

// Subtle Islamic geometric backdrop
export const GeometricPattern = ({ className = "", opacity = 0.08 }) => (
    <svg
        className={className}
        viewBox="0 0 400 400"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity }}
        aria-hidden="true"
    >
        <defs>
            <pattern
                id="star8"
                width="80"
                height="80"
                patternUnits="userSpaceOnUse"
            >
                <g stroke="#b89658" strokeWidth="0.5" fill="none">
                    <polygon points="40,10 48,32 70,32 52,46 60,68 40,55 20,68 28,46 10,32 32,32" />
                    <circle cx="40" cy="40" r="22" />
                </g>
            </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#star8)" />
    </svg>
);

// Delicate corner flourish
export const CornerFlourish = ({
    className = "",
    rotate = 0,
    size = 90,
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={{ transform: `rotate(${rotate}deg)` }}
        aria-hidden="true"
    >
        <g stroke="#b89658" strokeWidth="0.7" fill="none" opacity="0.75">
            <path d="M4 4 L 40 4" />
            <path d="M4 4 L 4 40" />
            <path
                d="M10 10 C 20 10, 26 16, 26 26 C 26 20, 32 14, 40 14"
                strokeWidth="0.5"
            />
            <circle cx="6" cy="6" r="1.6" fill="#b89658" />
        </g>
    </svg>
);

// Crescent motif for Nikah
export const Crescent = ({ className = "", size = 60 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 60 60"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
    >
        <path
            d="M42 30 A 18 18 0 1 1 30 12 A 14 14 0 1 0 42 30 Z"
            stroke="#b89658"
            strokeWidth="0.7"
            fill="none"
        />
    </svg>
);
